import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/banners`, {params})
    },
    create(params) {
        return Vue.axios.post(`/banners/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/banners/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/banners/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/banners/${id}`)
    },
    updateSort(data) {
        return Vue.axios.post(`/banners/sort/update`, data)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
